import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {ZadApiError} from '../zad/errors'
import {
  fetchMyZadSalesValidationPermission,
  fetchZadSalesValidationAudit,
  fetchZadSalesValidationPermissions,
  setZadSalesValidationPermission,
} from './service'
import {ZadSalesValidationPermissionState} from './types'

const initialState: ZadSalesValidationPermissionState = {
  me: null,
  meLoading: false,
  meInitialized: false,
  meFailed: false,
  users: [],
  listLoading: false,
  listInitialized: false,
  saveLoading: false,
  audits: [],
  auditLoading: false,
  error: null,
  errorCode: null,
  errorStatus: null,
}

function applyRejected(state: ZadSalesValidationPermissionState, action: PayloadAction<any>) {
  const payload = (action.payload || {}) as ZadApiError
  state.error = payload.error || 'Request failed'
  state.errorCode = payload.errorCode || null
  state.errorStatus = payload.status || null
}

function clearError(state: ZadSalesValidationPermissionState) {
  state.error = null
  state.errorCode = null
  state.errorStatus = null
}

const zadSalesValidationPermissionSlice = createSlice({
  name: 'zadSalesValidationPermission',
  initialState,
  reducers: {
    clearZadSalesValidationPermissionError: (state) => {
      clearError(state)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMyZadSalesValidationPermission.pending, (state) => {
      state.meLoading = true
      state.meFailed = false
      clearError(state)
    })
    builder.addCase(fetchMyZadSalesValidationPermission.rejected, (state, action: PayloadAction<any>) => {
      applyRejected(state, action)
      state.meLoading = false
      state.meInitialized = true
      state.meFailed = true
      state.me = null
    })
    builder.addCase(fetchMyZadSalesValidationPermission.fulfilled, (state, action) => {
      state.meLoading = false
      state.meInitialized = true
      state.meFailed = false
      clearError(state)
      state.me = action.payload.me
    })

    builder.addCase(fetchZadSalesValidationPermissions.pending, (state) => {
      state.listLoading = true
      clearError(state)
    })
    builder.addCase(fetchZadSalesValidationPermissions.rejected, (state, action: PayloadAction<any>) => {
      applyRejected(state, action)
      state.listLoading = false
      state.listInitialized = true
    })
    builder.addCase(fetchZadSalesValidationPermissions.fulfilled, (state, action) => {
      state.listLoading = false
      state.listInitialized = true
      clearError(state)
      state.users = action.payload.users
    })

    builder.addCase(setZadSalesValidationPermission.pending, (state) => {
      state.saveLoading = true
      clearError(state)
    })
    builder.addCase(setZadSalesValidationPermission.rejected, (state, action: PayloadAction<any>) => {
      applyRejected(state, action)
      state.saveLoading = false
    })
    builder.addCase(setZadSalesValidationPermission.fulfilled, (state) => {
      state.saveLoading = false
      clearError(state)
    })

    builder.addCase(fetchZadSalesValidationAudit.pending, (state) => {
      state.auditLoading = true
      clearError(state)
    })
    builder.addCase(fetchZadSalesValidationAudit.rejected, (state, action: PayloadAction<any>) => {
      applyRejected(state, action)
      state.auditLoading = false
    })
    builder.addCase(fetchZadSalesValidationAudit.fulfilled, (state, action) => {
      state.auditLoading = false
      clearError(state)
      state.audits = action.payload.audits
    })
  },
})

export default zadSalesValidationPermissionSlice.reducer
export const actions = zadSalesValidationPermissionSlice.actions
export {initialState as zadSalesValidationPermissionInitialState}
